module.exports = __webpack_public_path__ + "static/media/recepcion.320bc347.png";